"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    objectsTable: {
        path: "/objects/:groupId",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3VzdG9tT2JqZWN0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvY3VzdG9tT2JqZWN0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBc0M7QUFFekIsUUFBQSxNQUFNLEdBQUcsSUFBQSxtQkFBVyxFQUFDO0lBQ2hDLFlBQVksRUFBRTtRQUNaLElBQUksRUFBRSxtQkFBbUI7S0FDMUI7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIG9iamVjdHNUYWJsZToge1xuICAgIHBhdGg6IFwiL29iamVjdHMvOmdyb3VwSWRcIixcbiAgfSxcbn0pO1xuIl19